import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
const host = window.location.hostname;
console.log("hostame", host);

function AppWrapper() {
  const [AppComponent, setAppComponent] = useState(null);

  useEffect(() => {
    const loadApp = async () => {
      document.body.classList.remove("theme1-font", "theme2-font");
      // For Techniajz site---->
      if (host === "techniajz.com") {
        const { default: TechniajzApp } = await import(
          "./techniajz/src/app/App"
        );
        await import("./techniajz/src/assets/scss/App.scss");
        // await import("bootstrap/dist/css/bootstrap.min.css");
        document.body.classList.add("theme1-font");
        setAppComponent(() => TechniajzApp);
      }
      // For Algoza site---->
      else if (
        host === "algozatechnologies.com" ||
        host === "www.algozatechnologies.com"
      ) {
        const { default: AlgozaApp } = await import("./algoza/src/app/App");
        await import("./algoza/src/assets/scss/App.scss");
        // await import("bootstrap/dist/css/bootstrap.min.css");
        document.body.classList.add("theme2-font");
        setAppComponent(() => AlgozaApp);
      }
      // For UpMyTeam site--->
      else if (host === "upmyteam.com") {
        const { default: UpMyTeam } = await import("./upmyteam/src/App");
        // await import("./upmyteam/src/App.css");
        // await import("react-toastify/dist/ReactToastify.css");

        setAppComponent(() => UpMyTeam);
      }
    };

    loadApp();
  }, []);

  // Prevent rendering until styles and app are ready
  if (!AppComponent) return null;

  return <AppComponent />;
}

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <AppWrapper />
    </Provider>
  </BrowserRouter>
);

// import React from "react";
// import ReactDOM from "react-dom/client";
// import TechniajzApp from "./techniajz/src/app/App";
// import AlgozaApp from "./algoza/src/app/App";
// import UpMyTeam from "./upmyteam/src/App";
// import { BrowserRouter } from "react-router-dom";
// import { Provider } from "react-redux";
// import store from "./store/store";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// const host = window.location.hostname;

// if (host === "techniajz.com") {
//   import("./techniajz/src/assets/scss/App.scss");
//   import("bootstrap/dist/css/bootstrap.min.css");
// } else if (host === "algoza.com" || host === "localhost") {
//   import("./algoza/src/assets/scss/App.scss");
//   import("bootstrap/dist/css/bootstrap.min.css");
// } else if (host === "upmyteam.com") {
//   import("./upmyteam/src/App.css");
// }

// function getApp(host) {
//   if (host === "techniajz.com") {
//     document.body.classList.remove("theme2-font");
//     document.body.classList.add("theme1-font");
//     return <TechniajzApp />;
//   } else if (host === "algoza.com" || host === "localhost") {
//     document.body.classList.remove("theme1-font");
//     document.body.classList.add("theme2-font");
//     return <AlgozaApp />;
//   } else if (host === "upmyteam.com") {
//     return <UpMyTeam />;
//   }
// }
// root.render(
//   <BrowserRouter basename="/">
//     <Provider store={store}>{getApp(host)}</Provider>
//   </BrowserRouter>
// );

// import React, { useEffect, useState } from "react";
// import ReactDOM from "react-dom/client";
// import { BrowserRouter } from "react-router-dom";
// import { Provider } from "react-redux";
// import store from "./store/store";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// const host = window.location.hostname;

// function AppWrapper() {
//   const [AppComponent, setAppComponent] = useState(null);

//   useEffect(() => {
//     const loadApp = async () => {
//       // Clear any previous theme class
//       // document.body.classList.remove("theme1-font", "theme2-font");

//       if (host === "techniajz.com") {
//         const { default: TechniajzApp } = await import(
//           "./techniajz/src/app/App"
//         );
//         await import("./techniajz/src/assets/scss/App.scss");
//         await import("bootstrap/dist/css/bootstrap.min.css");
//         document.body.style.fontFamily =
//           '"Calibri", "Trebuchet MS", sans-serif';
//         setAppComponent(() => TechniajzApp);
//       } else if (host === "algoza.com") {
//         const { default: AlgozaApp } = await import("./algoza/src/app/App");
//         await import("./algoza/src/assets/scss/App.scss");
//         await import("bootstrap/dist/css/bootstrap.min.css");
//         document.body.style.fontFamily = "Livvic, sans-serif";
//       } else if (host === "upmyteam.com" || host === "localhost") {
//         const { default: UpMyTeam } = await import("./upmyteam/src/App");
//         await import("react-toastify/dist/ReactToastify.css");
//         await import("./upmyteam/src/App.css"); // Tailwind styles
//         setAppComponent(() => UpMyTeam);
//       }
//     };

//     loadApp();
//   }, []);

//   if (!AppComponent) return null;

//   return <AppComponent />;
// }

// root.render(
//   <BrowserRouter>
//     <Provider store={store}>
//       <AppWrapper />
//     </Provider>
//   </BrowserRouter>
// );
